import useFlatHierarchy from "backend/hooks/elements/useFlatHierarchy";
import useScorecardTopElement from "backend/hooks/model/useScorecardTopElement";
import StrategyToolbar from "components/toolbars/StrategyToolbar";
import { KPICard } from "design/components/cards/KPICard";
import MeasureGridArea from "design/components/grids/MeasureGridArea";
import { KpisHeader } from "design/components/texts/Headers";
import PageContainer from "design/layouts/PageContainer";
import Page from "design/pages/Page";
import { t } from "i18next";
import * as conf from "qpr-base/configuration";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useLink from "qpr-base/hooks/useLink";
import React from "react";

const KPIs = () => {
  const ctx = useAppContext();
  const link = useLink();
  const { data: root } = useScorecardTopElement("L0");

  const { data, isLoading, isPreviousData, isRefetching } = useFlatHierarchy(
    ctx.elementId || root?.id
  );

  return (
    <Page
      isLoading={isLoading || isPreviousData || isRefetching}
      Toolbar={StrategyToolbar}
    >
      <PageContainer width="1350px">
        <MeasureGridArea>
          <KpisHeader header={t("kpis.KPIs")} />
          {data
            ? data
                .filter((el) => el.typename === "KPI")
                .map((el) => (
                  <KPICard
                    settings={conf.getKPIsViewGaugeSettings(el)}
                    period={ctx.period || ""}
                    key={`${el.id}-${ctx.period}`}
                    element={el}
                    title={t("configtypes.Score (YTD)")}
                    onSelect={() => {
                      link({ page: "kpidetails", meaId: el.id });
                    }}
                  />
                ))
            : null}
        </MeasureGridArea>
      </PageContainer>
    </Page>
  );
};

export default KPIs;
